/**
 * @generated SignedSource<<d949487befd54919261e1a56d92d12d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utilitiesGetHasArticleSpeechArticle$data = {
  readonly articleSpeeches: ReadonlyArray<{
    readonly url: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "utilitiesGetHasArticleSpeechArticle";
};
export type utilitiesGetHasArticleSpeechArticle$key = {
  readonly " $data"?: utilitiesGetHasArticleSpeechArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"utilitiesGetHasArticleSpeechArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utilitiesGetHasArticleSpeechArticle"
};

(node as any).hash = "a78b7c8582a28f621e97d53b21a62e18";

export default node;
